export default __webpack_public_path__ + "static/media/2095-01.86e7c2cb.jpg";